import React from 'react';
export const Telegram = () => (
  <div className="contact-button telegram-button">
    <svg
      width="48"
      height="48"
      className="contact-svg"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.7 22.865 37.294 9.146c1.37-.571 2.891.617 2.668 2.084l-3.947 25.38c-.337 2.159-2.196 2.892-4.344 1.87l-11.025-7.373c-1.1-.763-1.225-2.4-.254-3.322l10.071-9.589c1.426-1.27.458-2.4-1.276-1.055l-13.49 9.21a5.567 5.567 0 0 1-4.751.697l-6.14-1.938c-1.02-.34-1.088-1.81-.104-2.245Z"
        fill="#FFF9F2"
      />
    </svg>
  </div>
);
